var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { syntheticEvent } from '../../../components/helpers';
import { chartLocalPoint, hideChartTooltip, positionChartTooltip } from '../../chartPrimitives';
import { getState, num, setParts } from '../../helpers';
import { getActiveDashboard } from '../../theme';
export function isInteractive(props) {
    return props.interactive !== false;
}
function localXY(group, e) {
    return chartLocalPoint(group, e.worldX, e.worldY);
}
function chartSize(group) {
    var state = getState(group);
    var w = num(state, 'width', 0) || num(state, 'size', 300);
    var h = num(state, 'height', 0) || num(state, 'size', 150);
    return { width: w, height: h };
}
function showTooltip(group, parts, label, centerX, topY, highlight) {
    var _a;
    if (!label.trim()) {
        clearTooltip(group, parts);
        return;
    }
    if (highlight && parts.highlight) {
        parts.highlight.x = highlight.x;
        parts.highlight.y = highlight.y;
        var hi = parts.highlight;
        hi.width = highlight.width;
        hi.height = highlight.height;
        parts.highlight.visible = true;
        parts.highlight.markDirty();
    }
    var bounds = chartSize(group);
    positionChartTooltip(parts.tooltip, parts.tooltipLabel, centerX, topY, label, bounds);
    parts.tooltip.markDirty();
    parts.tooltipLabel.markDirty();
    group.markDirty();
    (_a = group.getApp()) === null || _a === void 0 ? void 0 : _a.requestRender();
}
function clearTooltip(group, parts) {
    var _a, _b, _c;
    if (!parts.tooltip.visible && !((_a = parts.highlight) === null || _a === void 0 ? void 0 : _a.visible))
        return;
    hideChartTooltip(parts.tooltip, parts.tooltipLabel);
    if (parts.highlight)
        parts.highlight.visible = false;
    parts.tooltip.markDirty();
    parts.tooltipLabel.markDirty();
    (_b = parts.highlight) === null || _b === void 0 ? void 0 : _b.markDirty();
    group.markDirty();
    (_c = group.getApp()) === null || _c === void 0 ? void 0 : _c.requestRender();
}
function bindHover(group, parts, onMove) {
    var lastHoverKey = '';
    var handleMove = function (e) {
        var _a;
        var _b = localXY(group, e), x = _b.x, y = _b.y;
        var hit = onMove(x, y);
        if (!hit) {
            lastHoverKey = '';
            clearTooltip(group, parts);
            return;
        }
        var key = "".concat(hit.label, "|").concat(hit.centerX, "|").concat(hit.topY);
        if (key === lastHoverKey)
            return;
        lastHoverKey = key;
        showTooltip(group, parts, hit.label, hit.centerX, hit.topY, hit.highlight);
        group.emit('hover', syntheticEvent('hover', group, ((_a = hit.payload) !== null && _a !== void 0 ? _a : { value: hit.label })));
    };
    var handleClear = function () {
        lastHoverKey = '';
        clearTooltip(group, parts);
    };
    group.on('mousemove', handleMove);
    group.on('mouseleave', handleClear);
    parts.hitArea.on('mousemove', handleMove);
    parts.hitArea.on('mouseleave', handleClear);
    group.on('click', function (e) {
        var _a;
        var _b = localXY(group, e), x = _b.x, y = _b.y;
        var hit = onMove(x, y);
        if (hit)
            group.emit('select', syntheticEvent('select', group, ((_a = hit.payload) !== null && _a !== void 0 ? _a : { value: hit.label })));
    });
}
export function createHoverParts(app, rect, withHighlight) {
    if (withHighlight === void 0) { withHighlight = true; }
    var tooltip = app.roundedRect({
        width: 52,
        height: 24,
        cornerRadius: 6,
        fill: getActiveDashboard().chartTooltipBg,
        stroke: getActiveDashboard().chartTooltipBorder,
        strokeWidth: 1,
        visible: false,
        listening: false,
        zIndex: 900,
    });
    var tooltipLabel = app.text({
        text: '',
        fontSize: 11,
        fontWeight: 'bold',
        fill: getActiveDashboard().text,
        textAlign: 'center',
        x: 0,
        y: 0,
        visible: false,
        listening: false,
        zIndex: 901,
    });
    var hitArea = app.rect({
        x: rect.x,
        y: rect.y,
        width: rect.width,
        height: rect.height,
        fill: 'rgba(0,0,0,0.001)',
        listening: true,
        zIndex: 800,
    });
    var highlight = withHighlight
        ? app.rect({
            fill: 'rgba(96,165,250,0.28)',
            stroke: getActiveDashboard().chartLine,
            strokeWidth: 2,
            visible: false,
            listening: false,
        })
        : undefined;
    return { tooltip: tooltip, tooltipLabel: tooltipLabel, hitArea: hitArea, highlight: highlight };
}
export function mountHover(group, app, props, rect, onMove, withHighlight) {
    if (withHighlight === void 0) { withHighlight = true; }
    if (!isInteractive(props))
        return;
    var parts = createHoverParts(app, rect, withHighlight);
    var nodes = parts.highlight
        ? [parts.highlight, parts.tooltip, parts.tooltipLabel, parts.hitArea]
        : [parts.tooltip, parts.tooltipLabel, parts.hitArea];
    group.add.apply(group, __spreadArray([], __read(nodes), false));
    bindHover(group, parts, onMove);
    setParts(group, parts);
}
/** Index from plot-local X (columns, time series slots). */
export function attachIndexXHover(app, group, props, layout, count, labelAt, highlightAt, payloadAt) {
    if (!isInteractive(props) || count <= 0)
        return;
    var slot = layout.plotWidth / Math.max(count, 1);
    mountHover(group, app, props, { x: layout.plotX, y: layout.plotY, width: layout.plotWidth, height: layout.plotHeight }, function (x) {
        var idx = Math.max(0, Math.min(count - 1, Math.floor((x - layout.plotX) / slot)));
        var centerX = layout.plotX + slot * idx + slot / 2;
        return {
            label: labelAt(idx),
            centerX: centerX,
            topY: layout.plotY - 8,
            highlight: highlightAt === null || highlightAt === void 0 ? void 0 : highlightAt(idx),
            payload: payloadAt ? payloadAt(idx) : { index: idx, value: labelAt(idx) },
        };
    });
}
/** Index from plot-local Y (horizontal bars, row bands). */
export function attachIndexYHover(app, group, props, layout, count, labelAt, highlightAt) {
    if (!isInteractive(props) || count <= 0)
        return;
    var slot = layout.plotHeight / Math.max(count, 1);
    mountHover(group, app, props, { x: layout.plotX, y: layout.plotY, width: layout.plotWidth, height: layout.plotHeight }, function (_x, y) {
        var idx = Math.max(0, Math.min(count - 1, Math.floor((y - layout.plotY) / slot)));
        var centerY = layout.plotY + slot * idx + slot / 2;
        return {
            label: labelAt(idx),
            centerX: layout.plotX + layout.plotWidth / 2,
            topY: centerY - 32,
            highlight: highlightAt === null || highlightAt === void 0 ? void 0 : highlightAt(idx),
            payload: { index: idx, value: labelAt(idx) },
        };
    });
}
/** Vertical bands across full widget height (funnel, pyramid). */
export function attachBandYHover(app, group, props, width, height, count, labelAt) {
    if (!isInteractive(props) || count <= 0)
        return;
    var band = height / count;
    mountHover(group, app, props, { x: 0, y: 0, width: width, height: height }, function (_x, y) {
        var idx = Math.max(0, Math.min(count - 1, Math.floor(y / band)));
        return {
            label: labelAt(idx),
            centerX: width / 2,
            topY: idx * band + 4,
            highlight: { x: 0, y: idx * band, width: width, height: band },
            payload: { index: idx, value: labelAt(idx) },
        };
    });
}
/** Pie / doughnut slice by angle from center. */
export function attachPolarSliceHover(app, group, props, size, data, labels, innerRadius) {
    if (innerRadius === void 0) { innerRadius = 0; }
    if (!isInteractive(props) || !data.length)
        return;
    var cx = size / 2;
    var cy = size / 2;
    var outerR = size / 2 - 10;
    var total = data.reduce(function (a, b) { return a + b; }, 0) || 1;
    var start = -Math.PI / 2;
    var slices = data.map(function (val, i) {
        var sweep = (val / total) * Math.PI * 2;
        var slice = { start: start, end: start + sweep, val: val, i: i };
        start += sweep;
        return slice;
    });
    mountHover(group, app, props, { x: 0, y: 0, width: size, height: size }, function (x, y) {
        var dx = x - cx;
        var dy = y - cy;
        var r = Math.hypot(dx, dy);
        if (r < innerRadius || r > outerR)
            return null;
        var angle = Math.atan2(dy, dx);
        if (angle < -Math.PI / 2)
            angle += Math.PI * 2;
        var hit = slices.find(function (s) { return angle >= s.start && angle < s.end; });
        if (!hit)
            return null;
        var mid = (hit.start + hit.end) / 2;
        var lr = (outerR + innerRadius) / 2;
        var tx = cx + lr * Math.cos(mid);
        var ty = cy + lr * Math.sin(mid);
        var name = labels === null || labels === void 0 ? void 0 : labels[hit.i];
        var label = name !== null && name !== void 0 ? name : String(hit.val);
        return {
            label: label,
            centerX: tx,
            topY: ty - 28,
            payload: { index: hit.i, value: hit.val, label: name },
        };
    }, false);
}
/** Matrix / grid cell hover. */
export function attachGridHover(app, group, props, width, height, rows, cols, valueAt) {
    if (!isInteractive(props) || rows <= 0 || cols <= 0)
        return;
    var cw = width / cols;
    var ch = height / rows;
    mountHover(group, app, props, { x: 0, y: 0, width: width, height: height }, function (x, y) {
        var col = Math.max(0, Math.min(cols - 1, Math.floor(x / cw)));
        var row = Math.max(0, Math.min(rows - 1, Math.floor(y / ch)));
        var label = valueAt(row, col);
        if (!label.trim())
            return null;
        return {
            label: label,
            centerX: col * cw + cw / 2,
            topY: row * ch - 4,
            highlight: { x: col * cw, y: row * ch, width: cw, height: ch },
            payload: { row: row, col: col, value: valueAt(row, col) },
        };
    });
}
/** Nearest point in plot space (scatter, bubble, network nodes). */
export function attachNearestHover(app, group, props, rect, points, radius) {
    if (radius === void 0) { radius = 80; }
    if (!isInteractive(props) || !points.length)
        return;
    mountHover(group, app, props, rect, function (x, y) {
        var e_1, _a;
        var _b, _c;
        var best = null;
        var bestD = radius * radius;
        try {
            for (var points_1 = __values(points), points_1_1 = points_1.next(); !points_1_1.done; points_1_1 = points_1.next()) {
                var p = points_1_1.value;
                var d = Math.pow((p.x - x), 2) + Math.pow((p.y - y), 2);
                if (d < bestD) {
                    bestD = d;
                    best = p;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (points_1_1 && !points_1_1.done && (_a = points_1.return)) _a.call(points_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (!best)
            return null;
        var label = (_b = best.label) !== null && _b !== void 0 ? _b : '';
        if (!label.trim())
            return null;
        return {
            label: label,
            centerX: best.x,
            topY: best.y - 28,
            payload: (_c = best.payload) !== null && _c !== void 0 ? _c : { label: label },
        };
    }, false);
}
/** Hit-test axis-aligned regions (treemap, gantt, sankey nodes). */
export function attachRegionsHover(app, group, props, width, height, regions) {
    if (!isInteractive(props) || !regions.length)
        return;
    mountHover(group, app, props, { x: 0, y: 0, width: width, height: height }, function (x, y) {
        var _a, _b;
        var hit = regions.find(function (r) { return x >= r.x && x <= r.x + r.width && y >= r.y && y <= r.y + r.height; });
        if (!hit)
            return null;
        var label = (_a = hit.label) !== null && _a !== void 0 ? _a : '';
        if (!label.trim())
            return null;
        return {
            label: label,
            centerX: hit.x + hit.width / 2,
            topY: hit.y - 8,
            highlight: { x: hit.x, y: hit.y, width: hit.width, height: hit.height },
            payload: (_b = hit.payload) !== null && _b !== void 0 ? _b : { label: label },
        };
    });
}
/** Single-value or static tooltip on hover (bullet, pictogram). */
export function attachValueHover(app, group, props, width, height, label) {
    if (!isInteractive(props))
        return;
    mountHover(group, app, props, { x: 0, y: 0, width: width, height: height }, function () { return ({
        label: label,
        centerX: width / 2,
        topY: height * 0.2,
        payload: { value: label },
    }); }, false);
}
